export const BASE_URL_ENV = process.env.REACT_APP_BASE_URL;
export const PUBLIC_KEY_ENV = process.env.REACT_APP_PUBLIC_KEY;
export const NODE_ENV = process.env.NODE_ENV